import React from "react";
import { Button, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useStatusTrackerV2 } from "../hooks/useStatusTrackerV2";

const { Text } = Typography;

// Says the grid is in tagging mode and gives a way back out — a cell click opens the tag
// popover there, not the detail modal. The mode stays on across saves; this Cancel and the
// menu's Single Player toggle are what end it.
export const TaggingModeBanner = () => {
    const { state, actions } = useStatusTrackerV2();
    if (!state.taggingMode) return null;

    return (
        <div className="stv2-tagging-banner">
            <Text strong>Tagging mode</Text>
            <Text type="secondary">
                Pick a cell to flag a player for that date. Keep tagging as many as you need.
            </Text>
            <Button size="small" icon={<CloseOutlined />} onClick={() => actions.setTaggingMode(null)}>
                Done
            </Button>
        </div>
    );
};
